<template>
  <div class="register-page">
    <div
      class="register-background"
      aria-hidden="true"
    />
    <header class="register-header">
      <router-link to="/login">
        <img
          src="../images/ban6/left.png"
          alt=""
        >
        {{ $t('registerDesign.login') }}
      </router-link>
    </header>
    <main class="register-content">
      <h1>{{ $t('registerDesign.title') }}</h1>
      <form
        class="register-form"
        @submit.prevent="submit"
      >
        <div class="register-group">
          <label class="register-field">
            <img
              src="../images/ban6/user.png"
              alt=""
            >
            <input
              v-model.trim="data.unanme"
              type="text"
              name="unanme"
              autocomplete="username"
              :aria-label="$t('registerDesign.username')"
              aria-describedby="register-unanme-hint"
              :placeholder="$t('registerDesign.username')"
              @input="chageuname"
            >
          </label>
          <p
            id="register-unanme-hint"
            class="register-hint"
          >
            {{ $t('registerDesign.usernameHint') }}
          </p>
        </div>
        <div class="register-group">
          <label class="register-field">
            <img
              src="../images/ban6/lock.png"
              alt=""
            >
            <input
              v-model.trim="data.password"
              type="password"
              name="password"
              autocomplete="new-password"
              :aria-label="$t('registerDesign.password')"
              aria-describedby="register-password-hint"
              :placeholder="$t('registerDesign.password')"
            >
          </label>
          <p
            id="register-password-hint"
            class="register-hint"
          >
            {{ $t('registerDesign.passwordHint') }}
          </p>
        </div>
        <div class="register-group">
          <label class="register-field">
            <img
              src="../images/ban6/lock.png"
              alt=""
            >
            <input
              v-model.trim="data.spassword"
              type="password"
              name="spassword"
              autocomplete="new-password"
              :aria-label="$t('registerDesign.confirmPassword')"
              aria-describedby="register-spassword-hint"
              :placeholder="$t('registerDesign.confirmPassword')"
            >
          </label>
          <p
            id="register-spassword-hint"
            class="register-hint"
          >
            {{ $t('registerDesign.passwordHint') }}
          </p>
        </div>
        <div class="register-group">
          <label class="register-field">
            <img
              src="../images/ban6/user.png"
              alt=""
            >
            <input
              v-model.trim="data.t_mobile"
              type="text"
              name="t_mobile"
              autocomplete="off"
              :aria-label="$t('registerDesign.invitation')"
              aria-describedby="register-t_mobile-hint"
              :placeholder="$t('registerDesign.invitation')"
            >
          </label>
          <p
            id="register-t_mobile-hint"
            class="register-hint"
          >
            {{ $t('registerDesign.invitationHint') }}
          </p>
        </div>
        <div class="register-consent">
          <van-checkbox
            v-model="accepted"
            shape="square"
            checked-color="#efc49b"
            icon-size="14px"
          >
            {{ $t('registerDesign.consent') }}
            <span class="register-terms">
              {{ $t('registerDesign.terms') }}
            </span>
          </van-checkbox>
        </div>
        <button
          class="register-submit"
          type="submit"
          :disabled="submitting || configLoading || configFailed"
          :aria-busy="submitting"
        >
          <van-loading
            v-if="submitting"
            size="18px"
            color="currentColor"
          />
          {{ $t(submitting ? 'registerDesign.submitting' : 'registerDesign.submit') }}
        </button>
        <button
          v-if="configFailed"
          class="register-retry"
          type="button"
          @click="loadConfig"
        >
          {{ $t('registerDesign.retry') }}
        </button>
      </form>
    </main>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import { Checkbox, Loading } from 'vant';

export default {
  name: 'Register',
  components: { 'van-checkbox': Checkbox, 'van-loading': Loading },
  data() {
    return {
      accepted: true,
      submitting: false,
      configLoading: true,
      configFailed: false,
      config: {},
      data: {
        password: '', spassword: '', paypwd: '', mobile: '',
        t_mobile: '', telacc: '', unanme: '', code: '', agent: 10000,
      },
    };
  },
  created() {
    this.$parent.footer('user', false);
    this.getparams();
  },
  mounted() {
    if (this.$route.query.agent) {
      localStorage.setItem('agent', this.$route.query.agent);
      this.data.agent = this.$route.query.agent;
    } else if (localStorage.getItem('agent')) {
      this.data.agent = localStorage.getItem('agent');
    }
    this.loadConfig();
  },
  methods: {
    chageuname() {
      this.data.unanme = this.data.unanme.replace(/^\d+/, '').replace(/\s+/g, '');
    },
    getparams() {
      const m = this.$route.query.m;
      if (m && parseInt(m) > 0) {
        localStorage.setItem('t_mobile', m);
        this.data.t_mobile = m;
      } else {
        if (localStorage.getItem('t_mobile')) this.data.t_mobile = localStorage.getItem('t_mobile');
        if (localStorage.getItem('agent')) this.data.t_mobile = localStorage.getItem('agent');
      }
    },
    async loadConfig() {
      this.configLoading = true;
      this.configFailed = false;
      try {
        const res = await Fetch('/index/webconfig', { type: 'web' });
        this.config = res.data;
      } catch (error) {
        this.configFailed = true;
      } finally {
        this.configLoading = false;
      }
    },
    async submit() {
      if (this.submitting || this.configLoading || this.configFailed) return;
      if (!this.data.unanme) {
        this.$toast(this.$t('registerDesign.username'));
        return;
      }
      if (!this.data.password) {
        this.$toast(this.$t('register.passwordEmpty'));
        return;
      }
      if (!this.data.spassword || this.data.password !== this.data.spassword) {
        this.$toast(this.$t('register.passwordError'));
        return;
      }
      if (!this.data.code && this.config.sms_verify) {
        this.$toast(this.$t('register.codeEmpty'));
        return;
      }
      if (!this.accepted) {
        this.$toast(this.$t('registerDesign.consentRequired'));
        return;
      }
      this.submitting = true;
      this.data.mobile = this.data.unanme;
      try {
        const res = await Fetch('/index/register', {
          password: this.data.password,
          spassword: this.data.spassword,
          paypwd: this.data.paypwd,
          mobile: this.data.mobile,
          t_mobile: this.data.t_mobile,
          telacc: this.data.telacc,
          unanme: this.data.unanme,
          code: this.data.code,
          agent: this.data.agent,
        });
        if (res.data.token) localStorage.setItem('token', res.data.token);
        this.$toast(this.$t('register.signUpSuccess'));
        await this.$router.replace('/');
      } catch (error) {
        // Fetch shows API errors and rejects with an empty string.
        if (error) this.$toast(this.$t('registerDesign.failed'));
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.register-page {
  position: relative;
  isolation: isolate;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  overflow-x: hidden;
  background: #302d2b;
  color: #eee;
  box-sizing: border-box;
}
.register-background {
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)),
    url('../images/ban6/login.jpg') no-repeat left top;
  background-size: auto 100%;
  animation: register-pan 22s linear infinite;
}
@keyframes register-pan {
  0%, 100% { background-position-x: 0%; }
  50% { background-position-x: 100%; }
}
.register-header {
  padding: calc(12px + env(safe-area-inset-top, 0px)) 10px 0;
  a {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 32px;
    color: #f5cda7;
    font-size: 12px;
  }
  img { width: 18px; height: 18px; object-fit: contain; }
}
.register-content {
  width: 87%;
  margin: 0 auto;
  padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  h1 {
    margin: 24px 0 30px;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 400;
    text-align: center;
    color: #fff;
  }
}
.register-field {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #b7b2a5;
  border-radius: 7px;
  background: #2c2c2c;
  box-sizing: border-box;
  &:focus-within { border-color: #f5cda7; }
  img { width: 18px; height: 20px; object-fit: contain; flex-shrink: 0; }
  input {
    min-width: 0;
    width: 100%;
    height: 38px;
    padding: 0 0 0 9px;
    border: 0;
    outline: none;
    border-radius: 0;
    background: transparent;
    color: #f5bc84;
    caret-color: #f5bc84;
    font-size: 14px;
    text-align: left;
    box-sizing: border-box;
    &::placeholder { color: #bcbcbc; opacity: 1; }
    &:-webkit-autofill {
      -webkit-text-fill-color: #f5bc84;
      box-shadow: 0 0 0 1000px #2c2c2c inset;
    }
  }
}
.register-hint {
  margin: 8px 0 10px;
  padding-left: 20px;
  color: #ddd;
  font-size: 10px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.register-consent {
  margin-top: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(200, 177, 147, .35);
  font-size: 12px;
  line-height: 1.6;
  .register-terms { color: #f5bc84; }
  /deep/ .van-checkbox__label {
    color: #c4c4c4;
    font-size: 12px;
    line-height: 1.6;
    overflow-wrap: anywhere;
  }
  /deep/ .van-checkbox__icon { flex-shrink: 0; }
  /deep/ .van-checkbox__icon .van-icon { border-radius: 3px; }
}
.register-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  margin-top: 18px;
  padding: 9px 12px;
  border: 0;
  border-radius: 30px;
  background: linear-gradient(#ffe0c2, #eabd92);
  box-shadow: 0 3px 5px rgba(0, 0, 0, .15);
  color: #703825;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  &:disabled { opacity: .7; cursor: wait; }
}
.register-retry {
  display: block;
  margin: 12px auto 0;
  border: 0;
  background: transparent;
  color: #f5cda7;
  font-size: 12px;
  cursor: pointer;
}
@media (prefers-reduced-motion: reduce) {
  .register-background { animation: none; background-position-x: 50%; }
}
</style>
